$mol_icon_archive_arrow_down $mol_icon path \M3 3H21V7H3V3M4 21V8H20V21H4M14 14V11H10V14H7L12 19L17 14H14Z
